module.exports = __webpack_public_path__ + "static/media/ColourSans-Regular.0e7e5cf0.woff";